import { useCallback, useState } from 'react';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';
import { FaBook, FaMoneyBill, FaUserCircle, FaTachometerAlt, FaArrowAltCircleLeft, FaArrowAltCircleRight, FaPencilAlt } from 'react-icons/fa';
import { Avatar, Button, Heading, Text } from '@doist/reactist';

import useCurrentUser from './hooks/useCurrentUser';
import SidebarFlyout from './SidebarFlyout';
import { setHash } from './components/Modals/Modals';
import logo from './logo.png';

function AppSidebar({ expanded, onExpand }) {
    const currentUser = useCurrentUser();
    const [flyoutOpen, setFlyoutOpen] = useState(false);
    const closeFlyout = useCallback(() => {
        setFlyoutOpen(false);
    }, []);

    return (<>
        <Sidebar>
            <div className="carrot">
                {expanded === 'expanded' && (
                    <button onClick={onExpand}>
                        <FaArrowAltCircleLeft />
                    </button>
                )}
                {expanded === 'collapsed' && (
                    <button onClick={onExpand}>
                        <FaArrowAltCircleRight />
                    </button>
                )}
            </div>
            <Link to="/">
                <div className={`Logo ${expanded}`}>
                    <img src={logo} alt="Company Logo" className="logoImage" />
                </div>
            </Link>
            <Menu>
                <MenuItem component={<Link to="/" />} icon={<FaTachometerAlt />}>Dashboard</MenuItem>
                <MenuItem component={<Link to="/menus" />} icon={<FaBook />}>Menus</MenuItem>
                <MenuItem component={<Link to="/orders" />} icon={<FaMoneyBill />}>Orders</MenuItem>
                <MenuItem component={<Link to="/customers" />} icon={<FaUserCircle />}>Customers</MenuItem>
            </Menu>
            <div style={{ height: 120 }} />
            <div className={`userBox ${expanded}`} onClick={() => setFlyoutOpen(!flyoutOpen)}>
                <div className="userFlex">
                    {!!currentUser && (<>
                        <Avatar
                            exceptionallySetClassName="avatar"
                            size="xxl"
                            user={{
                                name: `${currentUser?.firstName} ${currentUser?.lastName}`,
                                email: currentUser?.email,
                            }}
                            avatarUrl={currentUser.avatar}
                        />
                        <Button
                            onClick={(evt) => { evt.preventDefault(); evt.stopPropagation(); setHash(`accountEdit/${currentUser._id}`); }}
                            style={{position: 'absolute', bottom: 10, left: 65, width: 20, height: 20, borderRadius: 10}}
                            variant="primary"
                            icon={<FaPencilAlt size="10px" />}
                        />
                        <div className="textData">
                            <Heading level={6} size="smaller">{`${currentUser?.firstName} ${currentUser?.lastName}`}</Heading>
                            <Text size="caption" tone="secondary">{currentUser?.email}</Text>
                        </div>
                    </>)}
                </div>
            </div>
        </Sidebar>
        {flyoutOpen && <SidebarFlyout expanded={expanded} close={closeFlyout} />}
    </>);
}

export default AppSidebar;